export default "__VITE_ASSET__xxGHyYCa__"